import { v4 } from 'uuid';

import { COVER_CATEGORIES } from '../../constants/domain-specific';
import {
  updateBlanketCovers,
  updateSpecifiedItems,
  updateTotalCoverValue,
} from '../../slices/coverDetails';
import { AppDispatch } from '../../store';
import { CoverTypes } from '../../types/cover';
import { Risk } from '../../types/policy';
import { RiskDetailBPKGeneralPropertyMachineryBreakdown } from '../../types/risk';

export const updatePortableItemsCoverAction = ({
  portableItemsRisk,
  dispatch,
}: {
  portableItemsRisk: Risk | undefined;
  dispatch: AppDispatch;
}) => {
  const portableItemsRiskDetails = (
    portableItemsRisk?.riskDetail as RiskDetailBPKGeneralPropertyMachineryBreakdown | undefined
  )?.riskBPKGeneralPropertyMachineryBreakdown;
  const portableItemsDetails = portableItemsRiskDetails?.generalProperty;
  const { itemList, generalPropertySumInsured } = portableItemsDetails!;
  const blanketCovers = itemList
    .filter((item) => item.serialNumber === CoverTypes.GENERAL)
    .map((item) => ({
      id: v4(),
      code: item.itemGroup,
      category: COVER_CATEGORIES.find((c) => c.id === item.itemGroup)!.description,
      value: item.itemSI,
      serialNumber: CoverTypes.GENERAL,
    }));
  const specifiedItems = itemList
    .filter((item) => item.serialNumber === CoverTypes.SPECIFIED)
    .map((item) => ({
      id: v4(),
      code: item.itemGroup,
      category: COVER_CATEGORIES.find((c) => c.id === item.itemGroup)!.description,
      description: item.itemDescription,
      value: item.itemSI,
      serialNumber: CoverTypes.SPECIFIED,
    }));

  dispatch(updateBlanketCovers(blanketCovers));
  dispatch(updateSpecifiedItems(specifiedItems));
  dispatch(updateTotalCoverValue(generalPropertySumInsured));
};
